export default "__VITE_ASSET__8b23b65f__"